import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9.5l-3 1.5l8 4l8 -4l-3 -1.5","key":"svg-0"}],["path",{"d":"M4 15l8 4l8 -4","key":"svg-1"}],["path",{"d":"M12 11v-7","key":"svg-2"}],["path",{"d":"M9 7l3 -3l3 3","key":"svg-3"}]]

const IconStackPop = createReactComponent('outline', 'stack-pop', 'StackPop', __iconNode);

export default IconStackPop;